/**
 * Time-ago utility for notification timestamps
 * Converts ISO date string to human-readable relative time
 */

import type { TFunction } from 'i18next';

export function timeAgo(timestamp: string, t?: TFunction): string {
  const now = new Date();
  const date = new Date(timestamp);
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (seconds < 60) return t ? t('TimeAgo_JustNow', { defaultValue: 'just now' }) : 'just now';

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60)
    return t
      ? t('TimeAgo_MinutesAgo', { defaultValue: '{{count}}m ago', count: minutes })
      : `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24)
    return t
      ? t('TimeAgo_HoursAgo', { defaultValue: '{{count}}h ago', count: hours })
      : `${hours}h ago`;

  const days = Math.floor(hours / 24);
  if (days < 30)
    return t ? t('TimeAgo_DaysAgo', { defaultValue: '{{count}}d ago', count: days }) : `${days}d ago`;

  const months = Math.floor(days / 30);
  if (months < 12)
    return t
      ? t('TimeAgo_MonthsAgo', { defaultValue: '{{count}}mo ago', count: months })
      : `${months}mo ago`;

  const years = Math.floor(months / 12);
  return t
    ? t('TimeAgo_YearsAgo', { defaultValue: '{{count}}y ago', count: years })
    : `${years}y ago`;
}
